import React, {ReactElement} from "react";
import {isFieldValid, PageStatus} from "ndr-designsystem";
import {useTranslation} from "react-i18next";
import {SectionRoot, SectionHeading, FieldGrid, TextInput} from "../../../Components/fields";
import SchemaConstants from "../../../utils/schemaConstants";
import {setMail, setMainContactName, setPhone} from "../store/TenantsSlice";
import {MainContactSchema} from "../../../validations/TenantDetailsValidation";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";

const MainContact = ({pageStatus}: {pageStatus: PageStatus}): ReactElement => {
    const isEditing = pageStatus === PageStatus.EDIT
    const isAdding = pageStatus === PageStatus.ADD
    const mainContactSchema = MainContactSchema(isAdding);
    const dispatch = useAppDispatch()
    const { currentTenant: tenant} = useAppSelector(state => state.Tenants)
    const {t} = useTranslation("tabels")

    return (
        <SectionRoot>
            <SectionHeading>{t("tenantDetails.tabs.mainContact")}</SectionHeading>
            <FieldGrid>
                <TextInput
                    label={t("tenantDetails.name")}
                    value={tenant?.mainContact?.name}
                    isEditing={isEditing || isAdding}
                    required={isAdding}
                    onChange={(name) => dispatch(setMainContactName(name))}
                    checkValue={name => isFieldValid(mainContactSchema, [SchemaConstants.name], { name })}
                />
                <TextInput
                    label={t("tenantDetails.phone")}
                    value={tenant?.mainContact?.phone}
                    isEditing={isEditing || isAdding}
                    required={isAdding}
                    maxLength={15}
                    onChange={(phone) => dispatch(setPhone(phone))}
                    checkValue={phone => isFieldValid(mainContactSchema, [SchemaConstants.phone], { phone })}
                />
                <TextInput
                    label={t("tenantDetails.email")}
                    value={tenant?.mainContact?.email}
                    isEditing={isEditing || isAdding}
                    required={isAdding}
                    onChange={(email) => dispatch(setMail(email))}
                    checkValue={email => isFieldValid(mainContactSchema, [SchemaConstants.email], { email })}
                />
            </FieldGrid>
        </SectionRoot>
    )
}

export default MainContact
